import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { ButtonComponent } from '../../buttons/button/button.component';
import { BannerConfig, BannerStyle } from '../banner-config';
import { InputSize } from '../../enum/input-size.enum';

@Component({
  selector: 'lib-large-banner',
  imports: [MatIcon, ButtonComponent],
  templateUrl: './large-banner.component.html',
  styleUrl: './large-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LargeBannerComponent {
  config = input.required<BannerConfig>();
  protected readonly BannerStyle = BannerStyle;
  protected readonly InputSize = InputSize;
}
